import { Box, Button, Tooltip } from "@common-ui/ui";
import React from "react";
import SummarizeIcon from "@mui/icons-material/Summarize";

export const GenerateReportBox = ({ params, status }) => {
  return (
    <Box>
      <Tooltip title="Detail Report" placement="right-end">
        <span>
          <Button
            id="generate"
            disabled={status !== "COMPLETED"}
            onClick={() =>
              window.open(
                `/reports/workevent/${params.row.work_event}/workitem/${params.id}`,
                "_blank"
              )
            }
            size="small"
            sx={{
              color: (theme) => theme.palette.grey[500],
              borderRadius: 2,
              border: "1px solid grey",
            }}
          >
            <SummarizeIcon fontSize="small" />
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
};
